export const upperBreakpointHorizontalSquareNum: number = 5;
export const underBreakpointHorizontalSquareNum: number = 3;
